import { BILLING_BASE } from './paths';

/**
 * The `page_name` sent with every credit-purchase analytics event, so the pipeline can tell the
 * surfaces apart.
 *
 * Derived from the route rather than written by hand: more than one billing tab opens the same
 * modals, and the `?purchaseModal=` link opens them on whichever tab it lands on. A literal per
 * surface would report the tab that owned the flow first.
 */
export type CreditsPurchasePageName =
  | 'settings.billing'
  | `settings.billing.${string}`
  | 'workspaces.home'
  | 'top-navigation.credits'
  | 'main-navigation.flex-card'
  | 'global-banner.credits';

/**
 * The page name for a purchase opened on `pathname`. Reads the tab from the path, so a tab added
 * later reports itself with no change here. A path with no tab (the billing shell alone) reports the
 * shell.
 */
export function creditsPurchasePageName(pathname: string): CreditsPurchasePageName {
  const withinBilling = pathname.startsWith(BILLING_BASE) ? pathname.slice(BILLING_BASE.length) : '';
  const tab = withinBilling.split('/').find((segment) => segment !== '');

  return tab == null ? 'settings.billing' : `settings.billing.${tab}`;
}
